module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-6.294 18.348l-1.434 1.368a1.046 1.046 0 0 1-1.432 0l-4.868-4.646-4.81 4.59a1.043 1.043 0 0 1-1.43 0l-1.434-1.368a.933.933 0 0 1 0-1.368l6.958-6.644a1.053 1.053 0 0 1 1.434 0l7.016 6.7a.94.94 0 0 1 0 1.368z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-square-2.js
// module id = 1478
// module chunks = 14